export default "__VITE_ASSET__DkprK2Hj__"